module.exports = __webpack_public_path__ + "static/media/chrissi.081c19e2.jpg";